// removed by extract-text-webpack-plugin
module.exports = {"root":"CategoryHeader__root___3o1mh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CategoryHeader/CategoryHeader.css
// module id = 958
// module chunks = 0